export const SET_ACTIVE_ARROW = 'SET_ACTIVE_ARROW'
export const SET_IS_TOUR_ACTIVE = 'SET_IS_TOUR_ACTIVE'

export function setActiveArrow (value) {
  return {
    type: SET_ACTIVE_ARROW,
    payload: value,
  }
}

export function setIsTourActive (value) {
  return {
    type: SET_IS_TOUR_ACTIVE,
    payload: value,
  }
}
